export const API_ERROR = "importExport_api_error";

// Import Models
export const GET_IMPORT_MODELS_LIST = "get_import_models_list";
export const GET_IMPORT_MODELS_LIST_SUCCESS = "get_import_models_list_success";

// Export Models
export const GET_EXPORT_MODELS_LIST = "get_export_models_list";
export const GET_EXPORT_MODELS_LIST_SUCCESS = "get_export_models_list_success";

// Export Status
export const EXPORT_STATUS = "export_status";
export const EXPORT_STATUS_SUCCESS = "export_status_success";

// Export Download
export const EXPORT_DOWNLOAD_FILE = "export_download_file";
export const EXPORT_DOWNLOAD_FILE_SUCCESS = "export_download_file_success";

// Download Export Data
export const DOWNLOAD_EXPORT_DATA = "download_export_data";
export const DOWNLOAD_EXPORT_DATA_SUCCESS = "download_export_data_success";

// Import Upload Status
export const IMPORT_UPLOAD_STATUS = "import_upload_status";
export const IMPORT_UPLOAD_STATUS_SUCCESS = "import_upload_status_success";

// Upload Import Data
export const UPLOAD_IMPORT_DATA = "upload_import_data";
export const UPLOAD_IMPORT_DATA_SUCCESS = "upload_import_data_success";

// Upload Table Preview Data
export const UPLOAD_TABLE_PREVIEW_DATA = "upload_table_preview_data";
export const UPLOAD_TABLE_PREVIEW_DATA_SUCCESS = "upload_table_preview_data_success";

// UI Actions
export const INPUT_CHANGE_VALUE = "importExport_input_change_value";
export const NEXT_STEP = "importExport_next_step";
export const PREV_STEP = "importExport_prev_step";
export const FINISH_STEP = "importExport_finish_step";
export const CHANGE_TYPE = "importExport_change_type";
export const CLEAR_DATA = "importExport_clear_data";
